<template>
  <div>
    <Header :title="$t('account.title')" />
    <div class="full-page-box" style="min-height: calc(100vh)">
      <div class="bank-box">
        <p>{{ $t("bank.msg") }}</p>
        <van-form @submit="onSubmit">
          <van-cell-group>
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("bank.name") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="username"
              :placeholder="$t('bank.name')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("bank.bank") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="bank"
              :placeholder="$t('bank.bank')"
              :rules="[{ required: true }]"
            />
            <van-cell>
              <template #title>
                <van-badge dot>
                  {{ $t("bank.card") }}
                </van-badge>
              </template>
            </van-cell>
            <van-field
              class="input"
              v-model="bank_code"
              :placeholder="$t('bank.card')"
              :rules="[{ required: true }]"
            />
            <van-cell v-show="!is_bind">
              <template #title>
                <van-badge dot>
                  mật khẩu quỹ
                </van-badge>
              </template>
            </van-cell>
            <van-field v-show="!is_bind"
              class="input"
              type="password"
              v-model="paypassword"
              placeholder="mật khẩu quỹ"
              :rules="[{ required: true }]"
            />
          </van-cell-group>
          <p class="info">{{ $t("bank.info") }}</p>
          <div style="margin-top: 16px">
            <van-button block class="btn" native-type="submit" v-show="!is_bind">{{
              $t("common.confirm")
            }}</van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/header";
import { Toast } from "vant";
export default {
  name: "BankView",
  components: { Header },
  data() {
    return {
      username: null,
      mobile: null,
      bank: null,
      bank_code: null,
      bankid: null,
      is_bind:true,
      paypassword:null,
    };
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'home' });
    }
  },
  mounted(){
    this.getUserBankInfo()
  },
  methods: {
    onSubmit() {
      this.$http({
        method: "post",
        data: {
          bankid: this.bank_code,
          bank: this.bank,
          bank_code: this.bank_code,
          username: this.username,
          mobile: this.mobile,
          paypassword:this.paypassword
        },
        url: "user_set_bank",
      }).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
          this.getUserBankInfo()
        } else {
          Toast(res.msg);
        }
      });
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code == 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.username = res.data.info.username
            this.bank = res.data.info.bankinfo
            this.bank_code = res.data.info.bankid
          }else {
            this.is_bind = false;
          }
        }else{
          Toast(res.msg);
        }
      })
    }
  },
};
</script>
<style scoped>
.bank-box {
  width: 90%;
  margin: 15px auto;
  line-height: 1.6;
}
.bank-box .input {
  border: 1px solid rgb(4 109 181) !important;
  border-radius: 8px;
}
.bank-box .btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181);
  color: #fff;
  border-radius: 8px;
}
.bank-box .info {
  color: rgb(4 109 181);
  margin-top: 16px;
}
</style>
